import type { ReactNode } from 'react';

export const symbol_pill_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M840-615q0 45-17 86t-49 73l-74 74q-9 9-21 9t-21-9q-9-9-9-21t9-21l74-74q22.86-22.72 35.43-53.39T780-615q0-69-48-117t-116.76-48q-33.24 0-63.89 12.57T498-732l-74 74q-9 9-21 9t-21-9q-9-9-9-21t9-21l74-74q32-32 73-49t86-17q94 0 159.5 65.5T840-615ZM345-180q32 0 63.01-12.57Q439.03-205.14 462-228l90-90-234-234-89.7 89.7Q205-439 192.5-408.42 180-377.84 180-345q0 69 48 117t117 48Zm249-96-90 90q-32 32-73 49t-86 17q-94 0-159.5-65.5T120-345q0-45 17-86t49-73l90-90L85-785q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l707 707q9 9 8.5 21T834-78q-9 9-21 9t-21-9L594-276ZM435-435Zm85-85Z"
		/>
	</svg>
);
